import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: true });

export default NProgress;